import React, { Component } from 'react';
import { Tabs } from 'antd';

import LeadForm from './components/LeadForm/LeadForm';
import ProgrammeSearchPane from './components/ProgrammeSearchPane/ProgrammeSearchPane';

const TabPane = Tabs.TabPane;

export class LeadManagementPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            activeTab: 'detail'
        };
    }

    componentDidMount() {
        const { location } = this.props;
        const { hash } = location;

        if (hash) {
            this.setState({ activeTab: hash.substring(1) })
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const { location } = this.props;
        const { hash } = location;

        if (hash !== prevProps.location.hash)
            this.setState({ activeTab: hash.substring(1) })
    }

    render() {
        const { location, history, match } = this.props;
        const { activeTab } = this.state;
        const leadId = match.params.leadId;
        const isCreateNewLead = leadId === undefined;

        return (
            <div className="ManagementPage">
                <h2>{isCreateNewLead ? 'Create New Lead' : 'Edit Lead'}</h2>
                <Tabs 
                    activeKey={activeTab}
                    type="card" 
                    tabBarGutter={5}
                    onChange={(key) => history.push(`${location.pathname}#${key}`)}
                >
                    <TabPane tab="Detail" key="detail">
                        <LeadForm leadId={leadId}/>
                    </TabPane>
                </Tabs>
                <ProgrammeSearchPane/>
            </div>
        );
    }
}

export default LeadManagementPage;


// WEBPACK FOOTER //
// ./src/scenes/DashboardPage/scenes/LeadManagementPage/LeadManagementPage.js